<template lang="pug">
v-app
  v-container(grid-list-xl, fluid, Poppins)
    v-layout(row, wrap, v-if="!estabelecimentoSelecionado")
      v-flex.text-xs-center
        WarningSelect
    v-layout(row, wrap, v-if="estabelecimentoSelecionado && loadingHorario")
      v-flex.text-xs-center
        v-progress-linear(:indeterminate="true").ma-1
    v-layout(row, wrap, v-if="estabelecimentoSelecionado && !loadingHorario")
      v-flex(lg12)

        v-tabs.tabsHorarios(v-model="activeTab", color="white", slider-color="primary")

          v-tab(href="#horarios") Horários

          v-tab(href="#feriados")
            | Feriados
            v-chip.ml-2(v-if="feriados.length", small, color="warning", text-color="white") {{ feriados.length }}

          //- touchless: sem ele o arrasto lateral no calendário troca de tab
          v-tabs-items(v-model="activeTab", touchless)

            //- ── Tab Horários ──────────────────────────────
            v-tab-item(id="horarios")
              .horariosTab
                form.horariosForm(@submit.prevent="salvar")

                  .horariosForm__topo
                    span.horariosForm__eyebrow Configuração
                    h3.horariosForm__titulo Horários da semana
                    p.horariosForm__sub
                      | Use o turno 2 quando a loja fecha para um intervalo e reabre no mesmo dia.
                      |  Para atender de madrugada, basta informar o horário final (ex.: 19:00 às 00:30).

                  .horariosForm__cabecalho
                    span.horariosForm__cabecalhoDia Dia
                    span.horariosForm__cabecalhoTurno
                      span.horariosForm__bolinha.horariosForm__bolinha--t1
                      | Turno 1
                    span.horariosForm__cabecalhoTurno
                      span.horariosForm__bolinha.horariosForm__bolinha--t2
                      | Turno 2

                  .diaRow(v-for="(dia, index) in dias", :key="dia.dia_semana", :class="{ 'diaRow--fechado': !temTurno(dia) }")
                    .diaRow__dia
                      span.diaRow__nome {{ dia.nome }}
                      span.diaRow__status(v-if="temTurno(dia)") {{ totalDia(dia) }} aberta
                      span.diaRow__status.diaRow__status--fechado(v-else) Fechada
                    .diaRow__turno(v-for="turno in turnos", :key="turno")
                      span.diaRow__turnoLabel
                        span.horariosForm__bolinha(:class="'horariosForm__bolinha--t' + turno")
                        | Turno {{ turno }}
                      .diaRow__campos
                        v-text-field.br-5.bgcw.inputDefault(type="time", v-model="dia['horario_inicio_' + turno]", color="primary", :disabled="loading", outline, label="De", :hide-details="true")
                        v-icon.diaRow__seta(size="16", color="#B0BEC5") arrow_forward
                        v-text-field.br-5.bgcw.inputDefault(type="time", v-model="dia['horario_fim_' + turno]", color="primary", :disabled="loading", outline, label="Até", :hide-details="true")
                        .diaRow__acao
                          v-tooltip(top)
                            v-btn.diaRow__copiar(icon, slot="activator", @click="copiarHorario(index, turno)", :disabled="loading", color="#CFD8ED")
                              v-icon(color="accent", size="18") file_copy
                            span Copiar horário de {{ nomeDiaAnterior(index) }}
                      .diaRow__madrugada(v-if="viraNoite(dia, turno)")
                        v-icon(size="12", color="#2463EB") brightness_4
                        | fecha {{ dia['horario_fim_' + turno] }} de {{ nomeDiaSeguinte(index) }}

                  .horariosForm__acoes
                    v-btn.btnSalvar(type="submit", depressed, round, dark, color="primary", :loading="loading")
                      v-icon.mr-1(size="18") check
                      | Salvar horários

                PreviewSemanaHorarios.mt-5(:dias="dias")

            //- ── Tab Feriados ──────────────────────────────
            v-tab-item(id="feriados")
              .feriadosTab

                //- Header da tab
                v-layout.feriadosTab__header(row, wrap, align-center)
                  v-flex
                    span.subheading.font-weight-medium(style="color:#37474F") Fechamentos agendados
                  v-flex.text-xs-right
                    v-btn.btnNovoFeriado(depressed, round, color="primary", @click="abrirAgendarFechamento")
                      v-icon.mr-1(small) add
                      | Agendar Fechamento

                //- Loading
                v-layout(row, wrap, v-if="loadingFeriados")
                  v-flex.text-xs-center.py-4
                    v-progress-circular(:indeterminate="true", color="primary", size="32")

                //- Empty state
                .feriadosEmpty(v-else-if="!feriados.length")
                  v-icon(size="56", color="grey lighten-2") event_available
                  p.feriadosEmpty__titulo Nenhum fechamento agendado
                  p.feriadosEmpty__desc Agende períodos de pausa sem precisar remover os horários de funcionamento

                //- Lista de feriados
                template(v-else)
                  v-card.feriadoCard(v-for="r in feriados", :key="r.id")
                    v-card-text.pb-0
                      v-layout.pr-4(row, wrap, align-center)
                        v-flex
                          v-chip(small, :color="isFuturo(r) ? '#FFF8E1' : '#FFF3E0'", text-color="#E65100")
                            v-icon(left, small, color="#E65100") {{ isFuturo(r) ? 'schedule' : 'storefront' }}
                            | {{ isFuturo(r) ? 'Agendado' : 'Em andamento' }}
                        v-spacer
                        .feriadoCard__pill {{ diffDias(r) }} dia{{ diffDias(r) > 1 ? 's' : '' }}
                    v-card-text.pt-2.pb-1
                      .feriadoCard__datas
                        v-icon(small, color="#90A4AE") calendar_today
                        span.feriadoCard__de  {{ $dayjs(r.data_inicio).format('DD/MM/YYYY') }} às {{ $dayjs(r.data_inicio).format('HH:mm') }}
                        v-icon(small, color="#90A4AE").mx-1 arrow_forward
                        span.feriadoCard__ate {{ $dayjs(r.data_fim).format('DD/MM/YYYY') }} às {{ $dayjs(r.data_fim).format('HH:mm') }}
                      p.feriadoCard__motivo(v-if="r.descricao") {{ r.descricao }}
                    v-card-actions.pt-0
                      v-spacer
                      v-btn(flat, round, color="error", @click="cancelarFeriado(r)", :loading="cancelando === r.id")
                        v-icon(left, small) delete_outline
                        | Cancelar agendamento

  v-dialog(v-model="dialogConfirmarCancel", width="520px", persistent)
    v-card.Poppins(v-if="feriadoParaCancelar")
      v-card-title.font-weight-semibold(style="font-size:17px; font-weight:600")
        v-icon.mr-2(color="error") warning
        | Cancelar agendamento?
      v-card-text
        p O fechamento agendado de
          strong  {{ $dayjs(feriadoParaCancelar.data_inicio).format('DD/MM/YYYY') }}
          |  até
          strong  {{ $dayjs(feriadoParaCancelar.data_fim).format('DD/MM/YYYY') }}
          |  será cancelado. A loja voltará a funcionar nos horários cadastrados.
      v-card-actions.px-4.pb-4.pt-0
        v-layout(row, wrap, style="width:100%")
          v-flex.xs12.sm6.pa-1
            v-btn(color="#FEFEFE", depressed, round, block, @click="dialogConfirmarCancel = false; feriadoParaCancelar = null") Manter
          v-flex.xs12.sm6.pa-1
            v-btn.white--text(:loading="cancelando !== null", depressed, round, block, color="error", style="white-space:normal; height:auto; min-height:36px; padding: 8px 12px;", @click="confirmarCancelamento")
              | Cancelar agendamento

  v-dialog(v-model="dialogSemHorario", width="560px", persistent)
    v-card.dialogBloqueio
      .dialogBloqueio__header
        .dialogBloqueio__header-iconWrap
          v-icon.dialogBloqueio__header-icon(color="white") event_busy
        .dialogBloqueio__header-text
          h2.dialogBloqueio__titulo Horários não preenchidos
          p.dialogBloqueio__subtitulo Nenhum horário de funcionamento configurado
      v-card-text.pt-4.pb-0.px-4
        p.dialogBloqueio__texto
          | Sua loja precisa ter pelo menos um horário de funcionamento cadastrado.
          | Se precisar pausar as atividades, use o agendamento de fechamento.
      v-card-actions.px-4.pb-4.pt-2
        v-layout(row, wrap, style="width:100%")
          v-flex.xs12.sm6.pa-1
            v-btn.btnCancelar(color="#FEFEFE", depressed, round, block, @click="cancelarSemHorario") Cancelar
          v-flex.xs12.sm6.pa-1
            v-btn.btnConfirmar.px-2(depressed, round, block, color="#e68000", @click="abrirAgendarFechamento")
              v-icon.mr-1(small) event_available
              | Agendar Fechamento

  DialogAgendarFechamento(ref="dialogAgendarFechamento", @agendado="onAgendado")
  OnboardingFab(etapa="etapa_horario")
</template>

<script>
import _ from 'lodash';
import WarningSelect from '@/components/WarningSelect';
import DialogAgendarFechamento from '@/components/dialog/DialogAgendarFechamento';
import OnboardingFab from '@/components/OnboardingFab';
import PreviewSemanaHorarios from '@/components/horario/PreviewSemanaHorarios';
import {
  criarDiasSemana,
  duracaoTurno,
  atravessaMeiaNoite,
  turnoValido,
  diaTemTurno,
  formatarDuracao,
  minutosAbertosDia,
} from '@/util/horario';

export default {
  components:{
    WarningSelect,
    DialogAgendarFechamento,
    OnboardingFab,
    PreviewSemanaHorarios,
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      activeTab: 'horarios',
      turnos: [1, 2],
      loadingHorario: false,
      loadingFeriados: false,
      loading: false,
      cancelando: null,
      dias: [],
      diasSalvos: [],
      horarios: [],
      horario: {},
      dialogSemHorario: false,
      feriados: [],
      dialogConfirmarCancel: false,
      feriadoParaCancelar: null,
    }
  },
  computed:{
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  created () {
     window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted(){
    this.onChangeEstabelecimento();
  },
  watch: {

  },
  methods: {
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO HORÁRIO', this.estabelecimentoSelecionado)
      if(this.estabelecimentoSelecionado){
        this.resetDias();
        this.getHorario();
        this.getFeriados();
      }
    },

    temTurno (dia) {
      return diaTemTurno(dia);
    },

    // Total dos dois turnos do dia, já contando quem atravessa a meia-noite e
    // sem somar duas vezes o trecho em que os turnos se sobrepõem.
    totalDia (dia) {
      return formatarDuracao(minutosAbertosDia(dia));
    },

    viraNoite (dia, turno) {
      const inicio = dia[`horario_inicio_${turno}`];
      const fim = dia[`horario_fim_${turno}`];
      return turnoValido(inicio, fim) && atravessaMeiaNoite(inicio, fim);
    },

    nomeDiaAnterior (index) {
      return index === 0 ? this.dias[this.dias.length - 1].nome : this.dias[index - 1].nome;
    },

    nomeDiaSeguinte (index) {
      return this.dias[(index + 1) % this.dias.length].nome;
    },

    copiarHorario (index, turno) {
      const vm = this;
      vm.dias[index]['horario_inicio_' + turno] = index == 0 ? vm.dias[vm.dias.length-1]['horario_inicio_' + turno] : vm.dias[index-1]['horario_inicio_' + turno];
      vm.dias[index]['horario_fim_' + turno] = index == 0 ? vm.dias[vm.dias.length-1]['horario_fim_' + turno] : vm.dias[index-1]['horario_fim_' + turno];
      vm.loading = true;
      vm.loading = false;
      window.getApp.$emit('APP_DIALOG_AUX');
    },

    resetDias () {
      this.dias = criarDiasSemana();
    },

    async getHorario () {
      const vm = this;
      try {
        if (!vm.estabelecimentoSelecionado) return;
        vm.loadingHorario = true;
        const response = await vm.$axios.get('/horario-funcionamento', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            ativo:1
          }
        });
        response.data.map(obj => {
          obj.horario_inicio_1 = obj.horario_inicio_1 ? vm.$dayjs(obj.horario_inicio_1, 'HH:mm').set({ second: 0, millisecond: 0 }).format('HH:mm') : null;
          obj.horario_fim_1 = obj.horario_fim_1 ? vm.$dayjs(obj.horario_fim_1, 'HH:mm').set({ second: 0, millisecond: 0 }).format('HH:mm') : null;
          obj.horario_inicio_2 = obj.horario_inicio_2 ? vm.$dayjs(obj.horario_inicio_2, 'HH:mm').set({ second: 0, millisecond: 0 }).format('HH:mm') : null;
          obj.horario_fim_2 = obj.horario_fim_2 ? vm.$dayjs(obj.horario_fim_2, 'HH:mm').set({ second: 0, millisecond: 0 }).format('HH:mm') : null;
          let dia = vm.dias[_.findIndex(vm.dias, { dia_semana: obj.dia_semana })];
          dia = _.merge(dia, obj);
        });
        vm.horario.id = true;
        vm.horarios = response.data;
        vm.diasSalvos = _.cloneDeep(vm.dias);
        vm.loadingHorario = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar as horários. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loadingHorario = false;
      }
    },
    minutesDiference(horario_inicio, horario_fim) {
      return duracaoTurno(horario_inicio, horario_fim);
    },
    minimumTime(horarios){
      const vm = this;

      for(let i in horarios){
        let firstTime = null, secondTime = null;
        const horario = horarios[i];
        if(horario.horario_inicio_1 && horario.horario_fim_1) firstTime = vm.minutesDiference(horario.horario_inicio_1, horario.horario_fim_1);
        if(horario.horario_inicio_2 && horario.horario_fim_2) secondTime = vm.minutesDiference(horario.horario_inicio_2, horario.horario_fim_2);

        if(firstTime == null && secondTime == null) continue;

        if(firstTime < 1 || (horario.horario_inicio_2 && horario.horario_fim_2 && secondTime < 1)) return false;
      }

      return true
    },
    horarioInvalido (horarios) {

      let erro = false;

      horarios.map(horario => {
        if (_.isNil(horario.horario_inicio_1) || horario.horario_inicio_1 === '') horario.horario_inicio_1 = null;
        if (_.isNil(horario.horario_fim_1) || horario.horario_fim_1 === '') horario.horario_fim_1 = null;
        if (_.isNil(horario.horario_inicio_2) || horario.horario_inicio_2 === '') horario.horario_inicio_2 = null;
        if (_.isNil(horario.horario_fim_2) || horario.horario_fim_2 === '') horario.horario_fim_2 = null;

        if (!_.isNil(horario.horario_inicio_1) && (_.isNil(horario.horario_fim_1))) {
          erro = true;
          window.getApp.$emit('APP_ALERT', { color: 'red', text: `Preencha corretamente o horário de ${horario.nome}!` });
        } else if (!_.isNil(horario.horario_fim_1) && (_.isNil(horario.horario_inicio_1))) {
          erro = true;
          window.getApp.$emit('APP_ALERT', { color: 'red', text: `Preencha corretamente o horário de ${horario.nome}!` });
        } else if (!_.isNil(horario.horario_inicio_2) && (_.isNil(horario.horario_fim_2))) {
          erro = true;
          window.getApp.$emit('APP_ALERT', { color: 'red', text: `Preencha corretamente o horário de ${horario.nome}!` });
        } else if (!_.isNil(horario.horario_fim_2) && (_.isNil(horario.horario_inicio_2))) {
          erro = true;
          window.getApp.$emit('APP_ALERT', { color: 'red', text: `Preencha corretamente o horário de ${horario.nome}!` });
        }
      });
      if (_.countBy(horarios, { horario_inicio_1: null, horario_fim_1: null, horario_inicio_2: null, horario_fim_2: null }).true == 7) {
        erro = true;
        window.getApp.$emit('APP_ALERT', { color: 'red', text: `Preencha o horário de pelo menos 1 dia!` });
      }
      return erro;
    },

    async salvarHorario () {
      const vm = this;
      try {
        const horarios = vm.dias;
        if(!vm.estabelecimentoSelecionado || !vm.horario.id || vm.horarioInvalido(horarios)) return;

        vm.loading = true;
        await vm.$axios.put('/horario-funcionamento', {
          estabelecimento_id: vm.estabelecimentoSelecionado.id,
          horario: horarios,
        });
        vm.loading = false;
        vm.diasSalvos = _.cloneDeep(vm.dias);
        window.getApp.$emit('APP_ALERT', { color: 'success', text: "Horários salvos com sucesso!" });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar as horários. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },

    async salvar () {
      const vm = this;
      try {
        const result = await vm.$validator.validateAll();
        if (!result) throw 'Preencha todos os campos corretamente!';
        if (vm.semHorarioFuncionamento()) {
          vm.dialogSemHorario = true;
          return;
        }
        vm.salvarHorario();
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: error });
        vm.loading = false;
      }
    },

    semHorarioFuncionamento () {
      const enums = this.$root.enums;
      const MINIMO_MINUTOS = parseInt(enums.MIN_TIME_DELIVERY || 30);

      return this.dias.every(dia => {
        const turno1Ok = dia.horario_inicio_1 && dia.horario_fim_1 &&
          this.minutesDiference(dia.horario_inicio_1, dia.horario_fim_1) >= MINIMO_MINUTOS;
        const turno2Ok = dia.horario_inicio_2 && dia.horario_fim_2 &&
          this.minutesDiference(dia.horario_inicio_2, dia.horario_fim_2) >= MINIMO_MINUTOS;
        return !turno1Ok && !turno2Ok;
      });
    },

    cancelarSemHorario () {
      this.dialogSemHorario = false;
      this.dias = _.cloneDeep(this.diasSalvos);
    },

    abrirAgendarFechamento () {
      this.dialogSemHorario = false;
      this.dias = _.cloneDeep(this.diasSalvos);
      this.$refs.dialogAgendarFechamento.open(this.estabelecimentoSelecionado);
    },

    onAgendado () {
      this.activeTab = 'feriados';
      this.getFeriados();
    },

    isFuturo (r) {
      return this.$dayjs(r.data_inicio).isAfter(this.$dayjs());
    },

    diffDias (r) {
      return this.$dayjs(r.data_fim).diff(this.$dayjs(r.data_inicio), 'day');
    },

    async getFeriados () {
      if (!this.estabelecimentoSelecionado) return;
      this.loadingFeriados = true;
      try {
        const { data } = await this.$axios.get('/recesso-estabelecimento', {
          params: { estabelecimento_id: this.estabelecimentoSelecionado.id, ativo: 1 },
        });
        const agora = this.$dayjs();
        this.feriados = data.filter(r =>
          this.$dayjs(r.data_fim).isAfter(agora) && r.admin_estabelecimento_id
        );
      } catch (_) {
        this.feriados = [];
      } finally {
        this.loadingFeriados = false;
      }
    },

    cancelarFeriado (r) {
      this.feriadoParaCancelar = r;
      this.dialogConfirmarCancel = true;
    },

    async confirmarCancelamento () {
      if (!this.feriadoParaCancelar || this.cancelando) return;
      const r = this.feriadoParaCancelar;
      try {
        this.cancelando = r.id;
        await this.$axios.put('/recesso-estabelecimento', { id: r.id, ativo: 0 });
        this.dialogConfirmarCancel = false;
        this.feriadoParaCancelar = null;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Agendamento cancelado com sucesso.' });
        this.getFeriados();
      } catch (_) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao cancelar agendamento. Tente novamente.' });
      } finally {
        this.cancelando = null;
      }
    },

  },
}
</script>

<style lang="scss">
  .inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
  }

  .inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
  }

  .tabsHorarios .v-tabs__bar {
    border-radius: 100px !important;
    overflow: hidden;
    padding: 0px 20px;
  }

  /* Campos de hora da tab Horários — acabamento mais leve que o .inputDefault padrão */
  .horariosForm .inputDefault .v-input__control .v-input__slot {
    background-color: #fff !important;
    border: 1px solid #D0D5DD !important;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, .04);
    transition: border-color .15s, box-shadow .15s;
  }

  .horariosForm .inputDefault .v-input__control .v-input__slot:hover {
    border-color: #B4BCC7 !important;
  }

  .horariosForm .inputDefault.v-input--is-focused .v-input__control .v-input__slot {
    border-color: #1d9a5a !important;
    box-shadow: 0 0 0 3px rgba(29, 154, 90, .12);
  }

  .horariosForm .inputDefault input {
    font-variant-numeric: tabular-nums;
    letter-spacing: .01em;
  }
</style>

<style lang="scss" scoped>
$primary: #1D9A5A;
$orange: #E65100;

.Poppins {
  font-family: "Poppins", "Roboto", "Helvetica";
}
.br-5 { border-radius: 5px !important; }
.br-10 { border-radius: 10px !important; }
.bgcw { background-color: #fff; }

.cardPadraoHorarios {
  box-shadow: none !important;
  background-color: transparent;
  margin-bottom: 25px;
}

// ── Tab Horários ────────────────────────────────────────────────────────────
$forte: #101828;
$medio: #475467;
$fraco: #667085;
$suave: #98A2B3;
$borda: #EAECF0;
$bordaLeve: #F2F4F7;
$azulTurno: #2463EB;

.horariosTab {
  padding: 20px 0 24px;
}

.horariosForm {
  border: 1px solid $borda;
  border-radius: 14px;
  background: #fff;
  padding: 22px 24px 20px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, .04);

  &__topo {
    margin-bottom: 20px;
  }

  &__eyebrow {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .13em;
    text-transform: uppercase;
    color: $suave;
  }

  &__titulo {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -.015em;
    color: $forte;
    margin: 5px 0 0;
  }

  &__sub {
    font-size: 13.5px;
    color: $fraco;
    line-height: 1.5;
    margin: 5px 0 0;
    max-width: 72ch;
  }

  &__cabecalho {
    display: grid;
    grid-template-columns: 136px 1fr 1fr;
    gap: 20px;
    padding: 0 12px 10px;
    border-bottom: 1px solid $borda;
  }

  &__cabecalhoDia,
  &__cabecalhoTurno {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: $suave;
  }

  &__opcional {
    font-size: 10.5px;
    font-weight: 500;
    letter-spacing: .04em;
    text-transform: none;
    color: #B6BEC8;
    border: 1px solid $borda;
    border-radius: 5px;
    padding: 0 6px;
    line-height: 17px;
  }

  &__bolinha {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    flex-shrink: 0;

    &--t1 { background: $primary; }
    &--t2 { background: $azulTurno; }
  }

  &__acoes {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    padding-top: 18px;
    border-top: 1px solid $bordaLeve;
  }
}

.diaRow {
  display: grid;
  grid-template-columns: 136px 1fr 1fr;
  gap: 4px 20px;
  align-items: start;
  padding: 11px 12px;
  transition: background-color .15s;

  &:hover {
    background-color: #FCFCFD;
  }

  & + & {
    border-top: 1px solid $bordaLeve;
  }

  &--fechado &__nome {
    color: $suave;
  }

  &__dia {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding-top: 14px;
  }

  &__nome {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -.01em;
    color: $forte;
  }

  &__status {
    font-size: 12px;
    color: $fraco;
    font-variant-numeric: tabular-nums;

    &--fechado {
      color: #C4CBD4;
    }
  }

  &__turno {
    min-width: 0;
  }

  &__turnoLabel {
    display: none;
    align-items: center;
    gap: 8px;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: $suave;
    margin-bottom: 7px;
  }

  &__campos {
    display: flex;
    align-items: center;
    gap: 8px;

    .v-input {
      min-width: 0;
    }
  }

  &__seta {
    flex: 0 0 auto;
  }

  &__acao {
    flex: 0 0 auto;
  }

  &__copiar {
    margin: 0 !important;
  }

  &__madrugada {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    color: $azulTurno;
    background: #F2F6FE;
    border: 1px solid #D8E4FC;
    border-radius: 12px;
    padding: 4px 11px;
    margin-top: 8px;
    width: fit-content;
  }
}

@media (max-width: 959px) {
  .horariosForm {
    padding: 18px 16px 16px;

    &__cabecalho {
      display: none;
    }

    &__acoes {
      margin-top: 16px;

      .btnSalvar {
        width: 100%;
      }
    }
  }

  .diaRow {
    grid-template-columns: 1fr;
    gap: 12px;
    border: 1px solid $borda;
    border-radius: 12px;
    padding: 14px;

    &:hover {
      background-color: transparent;
    }

    & + & {
      margin-top: 10px;
      border-top: 1px solid $borda;
    }

    &--fechado {
      background-color: #FCFCFD;
      border-style: dashed;
    }

    &__dia {
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      padding-top: 0;
    }

    &__turnoLabel {
      display: flex;
    }
  }
}

.btnSalvar {
  color: #fff;
  font-size: 14.5px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  margin: 0 !important;
  padding: 0 22px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, .1) !important;
}

.btnCancelar {
  font-weight: 500;
  color: #6B7A8D !important;
  text-transform: none;
  letter-spacing: 0;
}

.btnConfirmar {
  color: #fff;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

// ── Tab Feriados ────────────────────────────────────────────────────────────
.feriadosTab {
  padding: 20px 0;

  &__header {
    margin-bottom: 16px;
  }
}

.btnNovoFeriado {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

.feriadosEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0;
  text-align: center;

  &__titulo {
    font-size: 16px;
    font-weight: 600;
    color: #90A4AE;
    margin: 12px 0 4px;
  }

  &__desc {
    font-size: 13px;
    color: #BDBDBD;
    max-width: 320px;
    line-height: 1.5;
  }
}

.feriadoCard {
  border-radius: 10px !important;
  border-left: 4px solid $orange !important;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08) !important;

  &__pill {
    background: $orange;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    border-radius: 20px;
    padding: 3px 10px;
    white-space: nowrap;
  }

  &__datas {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    color: #37474F;
    flex-wrap: wrap;
  }

  &__de, &__ate {
    font-weight: 500;
  }

  &__motivo {
    font-size: 13px;
    color: #78909C;
    margin: 6px 0 0;
    font-style: italic;
  }
}

// ── Dialog de bloqueio ──────────────────────────────────────────────────────
.dialogBloqueio {
  border-radius: 12px !important;
  overflow: hidden;
  font-family: "Poppins", "Roboto", sans-serif;

  &__header {
    background-color: #e68000;
    padding: 22px 24px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__header-iconWrap {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__header-icon {
    font-size: 26px !important;
  }

  &__titulo {
    font-size: 17px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 2px;
    line-height: 1.3;
  }

  &__subtitulo {
    font-size: 13px;
    color: rgba(255,255,255,0.75);
    margin: 0;
    font-weight: 400;
  }

  &__texto {
    font-size: 13.5px;
    color: #5A6A7A;
    line-height: 1.6;
    text-align: justify;
    margin-bottom: 16px;
  }

  &__cta {
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: $primary;
    border-radius: 12px;
    padding: 14px 16px;
    cursor: pointer;
    text-align: left;
    transition: opacity 0.15s, transform 0.15s;
    box-shadow: 0 4px 16px rgba(29, 154, 90, 0.25);

    &:hover {
      opacity: 0.92;
      transform: translateY(-1px);
    }
    &:active {
      transform: translateY(0);
    }
  }

  &__ctaIcon {
    width: 44px;
    height: 44px;
    background: rgba(255,255,255,0.18);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__ctaContent {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__ctaTitulo {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
  }

  &__ctaDesc {
    font-size: 12px;
    color: rgba(255,255,255,0.75);
  }
}
</style>
